import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import 'scrolling-element';

function getWindow(): any {
  return window;
}
@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public isLoading = new BehaviorSubject(false);
  requestCount: any = 0;

  get nativeWindow() {
    return getWindow();
  }

  showLoading() {
    if (this.requestCount === 0) {
      this.isLoading.next(true);
      this.nativeWindow.document.scrollingElement.style.overflow = 'hidden';
    }
    this.requestCount++;
  }

  hideLoading() {
    if (this.requestCount === 0) {
      return;
    }

    this.requestCount--;

    if (this.requestCount === 0) {
      this.isLoading.next(false);
      this.nativeWindow.document.scrollingElement.style.overflow = '';
    }
  }

}
